import React from 'react';

import Details from '../components/container/Details';

const DetailProduct = () => {
  return <Details />;
};

export default DetailProduct;
